import React from "react";
import { ReactComponent as LightBrandIllustration } from "../../logo_light.svg";

const Brand = ({ width, height, size, mode }) => {
  const normalizedMode = String(mode || "default").toLowerCase();
  const resolvedWidth = width || size || 111;
  const resolvedHeight = height || (size ? Math.round((size * 48) / 111) : 48);

  if (normalizedMode === "light" || normalizedMode === "dark" || normalizedMode === "default") {
    return <LightBrandIllustration width={resolvedWidth} height={resolvedHeight} />;
  }

  return <LightBrandIllustration width={resolvedWidth} height={resolvedHeight} />;
};

export default Brand;
